import { render, staticRenderFns } from "./CurrentRisk.vue?vue&type=template&id=bbb55920&"
import script from "./CurrentRisk.vue?vue&type=script&lang=js&"
export * from "./CurrentRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports